import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { AppearanceService } from '../appearance/appearance.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { Constants } from '../../constants/constants';
import { AssetFieldModel } from 'src/app/models/asset_field.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetService 
{
  private lastAssetFields: Array<AssetFieldModel> = [];
  private lastObservation: ObservationModel = null;

  constructor(private apiService: APIService, private appearanceService: AppearanceService,
    private localStorageService: LocalStorageService,) 
  {
    this.initService();
  }


  initService()
  {
    this.apiService.baseUrl = Constants.PROD_URL;

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    this.lastAssetFields  = this.localStorageService.getLastAssetFields();
    this.lastObservation  = this.localStorageService.getLastObservation();
  }


  public createNewAssetType(data): any 
  { 
    return this.apiService.createNewAssetType(data).pipe(map((response: any) => {

        if (response.Success)
        {
          
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createAssetConditionReport(data): any 
  { 
    return this.apiService.createAssetConditionReport(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  public updateAssetConditionReport(data): any 
  { 
    return this.apiService.updateAssetConditionReport(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }
  

  public updateAssetType(data): any 
  { 
    return this.apiService.updateAssetType(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public updateObservation(data): any 
  { 
    return this.apiService.updateObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public removeRemedialStlFromObservation(data): any 
  { 
    return this.apiService.removeRemedialStlFromObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public addCustomRemedialStlToObservation(data): any 
  { 
    return this.apiService.addCustomRemedialStlToObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public removeCustomRemedialStlFromObservation(data): any 
  { 
    return this.apiService.removeCustomRemedialStlFromObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public markObservationAsRepaired(data): any 
  { 
    return this.apiService.markObservationAsRepaired(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addRecommendationToObservation(data): any 
  { 
    return this.apiService.addRecommendationToObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeRecommendationToObservation(data): any 
  { 
    return this.apiService.removeRecommendationToObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeRepairFromObservation(data): any
  {
    return this.apiService.removeRepairFromObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addObservationToAsset(data): any 
  { 
    return this.apiService.addObservationToAsset(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getSingleObservation(data): any 
  { 
    return this.apiService.getSingleObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteObservationFromAsset(data): any 
  { 
    return this.apiService.deleteObservationFromAsset(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deletePowerAlertForLocation(data): any 
  { 
    return this.apiService.deletePowerAlertForLocation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAlert(data): any 
  { 
    return this.apiService.deleteAlert(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  
  public getConditionReportDetails(data): any 
  { 
    return this.apiService.getConditionReportDetails(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAssetConditionReport(data): any 
  { 
    return this.apiService.deleteAssetConditionReport(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteRemedialFromJobAsset(data): any 
  { 
    return this.apiService.deleteRemedialFromJobAsset(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAssetPhoto(data): any 
  { 
    return this.apiService.deleteAssetPhoto(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public uploadAssetImage(data, url): any 
  { 
    return this.apiService.uploadAssetImage(data, url).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public uploadReportImage(data, url): any 
  { 
    return this.apiService.uploadReportImage(data, url).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAssetReportPhoto(data): any 
  { 
    return this.apiService.deleteAssetReportPhoto(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeAssetPowerIssue(data): any 
  { 
    return this.apiService.removeAssetPowerIssue(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removePowerIssueFromObservation(data): any 
  { 
    return this.apiService.removePowerIssueFromObservation(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getAssetDetails(assetUid, clientUid, organisationUid): any 
  { 
    var payload = {
      assetUid: assetUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.getAssetDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAsset(assetUid, clientUid, organisationUid): any 
  { 
    var payload = {
      assetUid: assetUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.deleteAsset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public changeNameOnObservation(payload)
  {
    return this.apiService.changeNameOnObservation(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  
  public getAssetTypeDetails(assetTypeUid, clientUid, organisationUid): any 
  { 
    var payload = {
      AssetTypeUid: assetTypeUid,
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    return this.apiService.getAssetTypeDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getAssetImage(s3Path, assetUid, clientUid, organisationUid): any 
  { 
    var payload = {
      s3Path: s3Path,
      assetUid: assetUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.getAssetImage(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getAssetReportImage(s3Path, reportUid, clientUid, organisationUid): any 
  { 
    var payload = {
      s3Path: s3Path,
      reportUid: reportUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.getAssetReportImage(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  } 

  public generateCondemnationCert(payload)
  {
    return this.apiService.generateCondemnationCert(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public getAllAssetTypesInAssetGroup(payload): any 
  { 
    return this.apiService.getAllAssetTypesInAssetGroup(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateAsset(payload): any 
  { 
    return this.apiService.updateAsset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addPowerIssueToObservation(payload): any 
  { 
    return this.apiService.addPowerIssueToObservation(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public exportAssetConditionReportByLocation(payload): any 
  { 
    return this.apiService.exportAssetConditionReportByLocation(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public createNewAssetTypeStlPreset(payload): any
  {
    return this.apiService.createNewAssetTypeStlPreset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public deleteAssetTypeStlPreset(payload)
  {
    return this.apiService.deleteAssetTypeStlPreset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public createNewAssetTypePreset(payload): any 
  { 
    return this.apiService.createNewAssetTypePreset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateAssetTypePreset(payload): any 
  { 
    return this.apiService.updateAssetTypePreset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  public deleteAssetType(assetTypeUid, clientUid, organisationUid): any 
  { 
    var payload = {
      assetTypeUid: assetTypeUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.deleteAssetType(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAssetTypePreset(presetUid, clientUid, organisationUid)
  {
    var payload = {
      presetUid: presetUid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.deleteAssetTypePreset(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }
  

  public addAssetHistoryLog(payload): any 
  { 
    return this.apiService.addAssetHistoryLog(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }



  public getLastAssetFields(): Array<AssetFieldModel>
  {
    if (this.lastAssetFields)
    {
      return this.lastAssetFields;
    }

    return [];
  }
  

  public getLastObservation(): ObservationModel
  {
    if (this.lastObservation)
    {
      return this.lastObservation;
    }

    return null;
  }


  public saveLastAssetValues(fields)
  {
    this.lastAssetFields = JSON.parse(JSON.stringify(fields));
    this.localStorageService.saveLastAssetFields(this.lastAssetFields)
  }


  public saveLastObservation(obs)
  {
    this.lastObservation = JSON.parse(JSON.stringify(obs));
    this.localStorageService.saveLastObservation(this.lastObservation)
  }
  
}
